var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
import SearchInput from '../SearchInput';
var StationSearchInput = function (_a) {
    var defaultValue = _a.defaultValue, onChange = _a.onChange, className = _a.className, _b = _a.InputProps, _c = _b === void 0 ? {} : _b, _d = _c.classes, cl = _d === void 0 ? {} : _d, InputProps = __rest(_c, ["classes"]);
    var classes = useStyles();
    return (_jsx(SearchInput, { defaultValue: defaultValue, onChange: onChange, className: clsx(classes.searchRoot, className), InputProps: __assign(__assign({}, InputProps), { classes: __assign(__assign({}, cl), { root: clsx(classes.searchInputRoot, cl.root) }) }) }, void 0));
};
export default StationSearchInput;
var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        searchRoot: (_a = {},
            _a[theme.breakpoints.down(500)] = {
                width: '100%',
                gridArea: 1,
                gridColumn: '1 / 3'
            },
            _a),
        searchInputRoot: {
            borderRadius: 5
        }
    });
});
//# sourceMappingURL=StationSearchInput.js.map